import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomainService } from 'src/app/core/domain/domain.service';
import { WindowRef } from 'src/app/core/domain/window-ref';
import { ProfileService } from 'src/app/core/translation/profile.service';
import { SAML_CODE } from './saml-code';

@Component({
    selector: 'app-saml-error',
    templateUrl: './saml-error.component.html',
    standalone: false
})
export class SamlErrorComponent implements OnInit {

  private translationIndex = 'samlError';
  private commonIndex = 'common';
  message: any;
  correlationId: string;
  date: string;
  info: string;
  errorCode: string;
  userEmail: string;
  homeUrl: string;

  constructor(private pfs: ProfileService, private route: ActivatedRoute, private windowRef: WindowRef, private domain: DomainService) { }

  ngOnInit(): void {
    this.message = Object.assign(this.pfs.messages[this.commonIndex], this.pfs.messages[this.translationIndex]);
    this.homeUrl = this.domain.getHomeUrl(this.windowRef.getHostname());
    this.route.queryParams.subscribe(params => {

      const errorMessage = params['errorMessage'];
      const errorCode = params['errorCode'];

      if (errorCode) {
        this.errorCode = errorCode;
        this.info = this.message[SAML_CODE[errorCode]];
      } else if (errorMessage) {
        const info = this.message[errorMessage];
        if (info) {
          this.info = info;
        } else {
          this.info = errorMessage;
        }
      } else {
        this.errorCode = '500';
        this.info = this.message[SAML_CODE[this.errorCode]];
      }

      this.userEmail = params['userEmail'];
      this.correlationId = params['correlationId'];
      const timestamp = params['timestamp'];
      if (timestamp) {
        this.date = new Date(parseInt(timestamp)).toUTCString();
      }
    });
  }

}
